import React, {useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import ServiceOfTerms from "./ServiceOfTerms";
import InputNameArea from "./InputNameArea";

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const ModalWindow = (props) => {
  const classes = useStyles();
  const [inputArea, handleInputArea] = useState(false)

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={props.open}
        onClose={props.handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={props.open}>
          {(!inputArea) ? (
              <ServiceOfTerms handleInputArea={handleInputArea}/>
          ) : (
              <InputNameArea />
          )}
        </Fade>
      </Modal>
    </div>
  );
}

export default ModalWindow